import { Language } from './Antiloop.js'
import { BaseObject } from './types.js'

export type PartialUser = Partial<User> & { id: string; authCustomClaims?: Partial<UserCustomClaims> }

export enum UserRole {
  User = 'user',
  Client = 'client',
  Admin = 'admin',
  Owner = 'owner',
  SuperAdmin = 'superadmin',
  Developer = 'developer'
}

/** Which feature (Room Booking or Marketing) the mobile admin app shows in the 3rd bottom-nav slot. */
export enum MobileMainMenuFeature {
  RoomBooking = 'roomBooking',
  Marketing = 'marketing'
}

export type UserCustomClaims = {
  clientIds: string[]
  roles: UserRole[]
  activityIds?: string[]
  portalUser?: boolean
  enrollmentUserId?: string
}

export type User = BaseObject &
  SignUpUserRequest & {
    id: string
    language?: Language
    lastActiveAt?: string
    email: string
    phone: string
    authCustomClaims: UserCustomClaims
    instructorForActivities?: string[] // List of activity IDs that this user is an instructor for
    isPrivateLessonInstructor?: boolean
    privateLessonSpecialties?: string[]
    isInvited?: boolean // Flag to track pending invitations
    canSeeEnrollmentDetails?: boolean
    selectedClientId?: string
    mobileMainMenuFeature?: MobileMainMenuFeature
  }

export type SignUpUserRequest = {
  email: string
  displayName?: string
  phone?: string
}

export type UserAuditLog = {
  id: string
  event: UserAuditLogEvent
  performedBy: { userId: string; userEmail: string } | 'system'
  targetUserId: string
  targetUserEmail: string
  clientId?: string
  changes: { field: string; oldValue: any; newValue: any }[]
  createdAt: string
}

export enum UserAuditLogEvent {
  UserInvited = 'user_invited',
  UserRoleUpdated = 'user_role_updated'
}
